
import { Form , Field, ChildForm } from '../form/form';
import { FormData } from '../form/formData';
import { SelectOption, Vo } from '../form/types';
import { Validators } from '@angular/forms'
import { ServiceAgent} from '../form/serviceAgent';

export class EligibilityListDownloadForm extends Form {
	private static _instance = new EligibilityListDownloadForm();
	studentId:Field = {
		name:'studentId'
		,controlType: 'Hidden'
		,label: 'studentId'
		,isRequired: true
		,valueType: 1
		,errorId: 'invalidId'
		,maxValue: 9999999999999
	};
	name:Field = {
		name:'name'
		,controlType: 'Output'
		,label: 'Name'
		,valueType: 0
		,errorId: 'invalidName'
		,maxLength: 150
	};
	usn:Field = {
		name:'usn'
		,controlType: 'Output'
		,label: 'USN'
		,valueType: 0
		,errorId: 'invalidText'
		,maxLength: 1000
	};
	cieMarks:Field = {
		name:'cieMarks'
		,controlType: 'Output'
		,label: 'CIE Marks'
		,valueType: 1
		,defaultValue: 0
		,errorId: 'invalidInteger'
		,maxValue: 9999999999999
	};
	overallAttendance:Field = {
		name:'overallAttendance'
		,controlType: 'Output'
		,label: 'overallAttendance'
		,valueType: 0
		,errorId: 'invalidText'
		,maxLength: 1000
	};
	isEligibleForExam:Field = {
		name:'isEligibleForExam'
		,controlType: 'Output'
		,label: 'Is Eligible'
		,valueType: 0
		,errorId: 'invalidText'
		,maxLength: 1000
	};
	isCondonable:Field = {
		name:'isCondonable'
		,controlType: 'Output'
		,label: 'Condonable'
		,valueType: 3
		,defaultValue: false
		,errorId: 'invalidBool'
	};
	isCondoned:Field = {
		name:'isCondoned'
		,controlType: 'Output'
		,label: 'Is Condoned'
		,valueType: 3
		,defaultValue: false
		,errorId: 'invalidBool'
	};

	public static getInstance(): EligibilityListDownloadForm {
		return EligibilityListDownloadForm._instance;
	}

	constructor() {
		super();
		this.fields = new Map();
		this.controls = new Map();
		this.controls.set('studentId', [Validators.required, Validators.max(9999999999999)]);
		this.fields.set('studentId', this.studentId);
		this.controls.set('name', [Validators.maxLength(150)]);
		this.fields.set('name', this.name);
		this.controls.set('usn', [Validators.maxLength(1000)]);
		this.fields.set('usn', this.usn);
		this.controls.set('cieMarks', [Validators.max(9999999999999)]);
		this.fields.set('cieMarks', this.cieMarks);
		this.controls.set('overallAttendance', [Validators.maxLength(1000)]);
		this.fields.set('overallAttendance', this.overallAttendance);
		this.controls.set('isEligibleForExam', [Validators.maxLength(1000)]);
		this.fields.set('isEligibleForExam', this.isEligibleForExam);
		this.controls.set('isCondonable', []);
		this.fields.set('isCondonable', this.isCondonable);
		this.controls.set('isCondoned', []);
		this.fields.set('isCondoned', this.isCondoned);
		this.opsAllowed = {get: true, filter: true};
		this.keyFields = ["subjectRegisterId"];
	}

	public getName(): string {
		 return 'eligibilityListDownload';
	}
}


export class EligibilityListDownloadFd extends FormData {
	constructor(form: EligibilityListDownloadForm, sa: ServiceAgent) {
		super(form, sa);
	}

	setFieldValue(name: 'studentId' | 'name' | 'usn' | 'cieMarks' | 'overallAttendance' | 'isEligibleForExam' | 'isCondonable' | 'isCondoned', value: string | number | boolean | null ): void {
		super.setFieldValue(name, value);
	}

	getFieldValue(name: 'studentId' | 'name' | 'usn' | 'cieMarks' | 'overallAttendance' | 'isEligibleForExam' | 'isCondonable' | 'isCondoned' ): string | number | boolean | null {
		return super.getFieldValue(name);
	}
}


export interface EligibilityListDownloadVo extends Vo {
	cieMarks?: number, 
	isCondoned?: boolean, 
	overallAttendance?: string, 
	isEligibleForExam?: string, 
	subjectRegisterId?: number, 
	studentId?: number, 
	usn?: string, 
	hasAttendanceShortage?: boolean, 
	subjectSectionId?: number, 
	isCondonable?: boolean, 
	name?: string, 
	instituteId?: number, 
	hasCieShortage?: boolean
}
